<!-- toddo当前仅支持单传，多传会有问题 -->
<template>
	<el-upload
		ref="upload"
		v-model:file-list="model"
		:action="uploadURL"
		:multiple="is_multi"
		:limit="limit"
		:on-success="success"
		:on-remove="handleRemove"
		:on-exceed="handleExceed"
		:before-upload="beforeUpload"
	>
		<slot>
			<el-button type="default" icon="Upload">上传文件</el-button>
		</slot>
	</el-upload>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import cfg from '@/config/config.js'
const uploadURL = cfg.HOST2 + '/XuelianAdmin/uploadOss'
const showImagePreview = ref(false)
const previewList = ref([])
const model = defineModel({ type: Array, default: [] })
const limit = ref(1)
const is_multi = ref(false)
const upload = ref()
const emit = defineEmits(['change'])
onMounted(() => {})

const beforeUpload = (file) => {
	let allowedFileTypes = []
	allowedFileTypes = [
		'image/jpeg', // JPEG 图像文件
		'image/png', // PNG 图像文件
		'video/mp4', // MP4 视频文件
		'video/avi', // AVI 视频文件 (请确认正确的MIME类型)
		'application/msword', // Microsoft Word 文档
		'application/vnd.ms-excel', // Microsoft Excel 表格
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'application/pdf',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'application/vnd.ms-excel.sheet.macroEnabled.12'
	]

	// 获取文件的类型
	const fileType = file.type
	if (!allowedFileTypes.includes(fileType)) {
		ElMessage({
			type: 'error',
			message: '上传格式错误'
		})
		return false // 阻止文件上传
	}
}
const success = (e) => {
	model.value = [
		{
			path: e.data.osspath,
			name: e.data.osspath
		}
	]
}
/**
 * 移除文件，删除
 * @param file
 */
function handleRemove(file) {
	model.value = []
	previewList.value = []
}

function handleExceed(files) {
	upload.value.clearFiles()
	upload.value.handleStart(files[0])
	upload.value.submit()
}
</script>

<style scoped>
:deep(.el-upload--picture-card) {
	--el-upload-picture-card-size: 120px;
}

:deep(.el-upload-list--picture-card) {
	--el-upload-list-picture-card-size: 120px;
}
</style>
